import { Component, OnInit } from "@angular/core";
import { SetupWizardService } from "@services/setup-wizard.service";
import { tap } from "rxjs/operators";

@Component({
  selector: "app-wizard-import",
  templateUrl: "./wizard-import.component.html",
  styleUrls: ["./wizard-import.component.scss", "../wizard-styles.scss"],
})
export class WizardImportComponent implements OnInit {
  public selectedIntegration;
  public integrations;
  public integrations$;
  public isLoading: boolean = true;
  public selectedIntegrationError: boolean;
  public selectedIntegrationErrorMessage;
  constructor(private wizardService: SetupWizardService) {}
  ngOnInit(): void {
    this.integrations$ = this.wizardService
      .getIntegrations$()
      .pipe(
        tap(({ isLoading }) => {
          this.isLoading = isLoading;
        })
      )
      .pipe(
        tap(({ list, selectedIntegration }) => {
          this.integrations = list;
          this.selectedIntegration = selectedIntegration;
        })
      );
  }

  get changes() {
    return this.wizardService.getImportInfoChanges();
  }

  saveImportInfo() {
    const shouldKickoffMassImport =
      this.changes === "updated" || this.changes === "addition";
    const updates = {} as any;
    if (this.wizardService.getCourseCodeChanges()) {
      updates.searchTerms =
        this.selectedIntegration.value.searchTerms;
    }

    if (this.wizardService.getDateChanges()) {
      updates.dateRange = this.selectedIntegration.value.dateRange;
    }

    if (this.wizardService.getTermChanges()) {
      updates.termsToPull = this.selectedIntegration.value.termsToPull.map(
        ({ id }) => String(id)
      );
    }
    this.wizardService.saveImportInfo$(shouldKickoffMassImport, updates);
  }

  updateSelectedIntegration(integration) {
    this.selectedIntegration = integration;
    integration.value.status === "ok"
      ? this.wizardService.selectIntegration(integration)
      : this.setSelectedIntegrationErrorMessage(integration.value);
    this.selectedIntegrationError = integration.value.status !== "ok";
  }

  setSelectedIntegrationErrorMessage(integration) {
    if (integration.isProcessing) {
      return (this.selectedIntegrationErrorMessage =
        "Integration is still processing");
    }
    if (integration?.tokensProcess?.status === "error") {
      return (this.selectedIntegrationErrorMessage =
        "Integration seems to have bad credentials set, unable to get valid access tokens.");
    }
    if (integration?.termsProcess?.status === "error") {
      return (this.selectedIntegrationErrorMessage =
        "Unable to get terms with the integration");
    }

    this.selectedIntegrationErrorMessage =
      "Error found with the integration selected";
  }
}
